"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _I18n = _interopRequireDefault(require("I18n"));

var _react = _interopRequireWildcard(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UITabs = _interopRequireDefault(require("UIComponents/nav/UITabs"));

var _UITab = _interopRequireDefault(require("UIComponents/nav/UITab"));

var _UIModal = _interopRequireDefault(require("UIComponents/dialog/UIModal"));

var _UIDialogCloseButton = _interopRequireDefault(require("UIComponents/dialog/UIDialogCloseButton"));

var _UIDialogBody = _interopRequireDefault(require("UIComponents/dialog/UIDialogBody"));

var _UIDialogFooter = _interopRequireDefault(require("UIComponents/dialog/UIDialogFooter"));

var _UIDialogHeader = _interopRequireDefault(require("UIComponents/dialog/UIDialogHeader"));

var _UIFormControl = _interopRequireDefault(require("UIComponents/form/UIFormControl"));

var _UITextInput = _interopRequireDefault(require("UIComponents/input/UITextInput"));

var _UITextArea = _interopRequireDefault(require("UIComponents/input/UITextArea"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIAlert = _interopRequireDefault(require("UIComponents/alert/UIAlert"));

var _errorCheck = require("../utils/errorCheck");

var _embed = require("../utils/embed");

var EmbedModal =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(EmbedModal, _React$Component);

  function EmbedModal(props) {
    var _this;

    (0, _classCallCheck2.default)(this, EmbedModal);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(EmbedModal).call(this, props));
    _this.state = {
      url: _this.props.url,
      embed: _this.props.embed,
      hasErrors: false,
      currentTab: _this.props.defaultTab
    };
    _this.submit = _this.submit.bind((0, _assertThisInitialized2.default)(_this));
    _this.clearEmbed = _this.clearEmbed.bind((0, _assertThisInitialized2.default)(_this));
    _this.clearUrl = _this.clearUrl.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(EmbedModal, [{
    key: "clearEmbed",
    value: function clearEmbed() {
      this.setState({
        embed: ''
      });
    }
  }, {
    key: "clearUrl",
    value: function clearUrl() {
      this.setState({
        url: ''
      });
    }
  }, {
    key: "showErrors",
    value: function showErrors(errorMsg) {
      return _react.default.createElement(_UIAlert.default, {
        type: "danger",
        className: "m-x-6 m-bottom-4"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: errorMsg
      }));
    }
  }, {
    key: "submit",
    value: function submit() {
      var _this$props = this.props,
          onSubmit = _this$props.onSubmit,
          onClose = _this$props.onClose,
          hasNoErrorsUrl = _this$props.hasNoErrorsUrl,
          hasNoErrorsCode = _this$props.hasNoErrorsCode;
      var _this$state = this.state,
          url = _this$state.url,
          embed = _this$state.embed,
          currentTab = _this$state.currentTab;

      if (currentTab === 0 && !hasNoErrorsUrl(url)) {
        this.setState({
          hasErrors: true
        });
      } else if (currentTab === 1 && !hasNoErrorsCode(embed)) {
        this.setState({
          hasErrors: true
        });
      } else {
        this.setState({
          hasErrors: false
        });
        onSubmit({
          url: url,
          embed: embed
        });
        onClose();
      }
    }
  }, {
    key: "renderErrors",
    value: function renderErrors() {
      var handleErrorMessage = this.props.handleErrorMessage;
      var _this$state2 = this.state,
          hasErrors = _this$state2.hasErrors,
          url = _this$state2.url,
          embed = _this$state2.embed;
      return hasErrors ? this.showErrors(handleErrorMessage({
        url: url,
        embed: embed
      })) : null;
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var _this2 = this;

      var _this$props2 = this.props,
          defaultTab = _this$props2.defaultTab,
          enableCodeTab = _this$props2.enableCodeTab;
      var _this$state3 = this.state,
          url = _this$state3.url,
          embed = _this$state3.embed,
          currentTab = _this$state3.currentTab;

      if (enableCodeTab) {
        return _react.default.createElement(_UITabs.default, {
          defaultSelected: defaultTab,
          selected: currentTab,
          use: "enclosed",
          onSelectedChange: function onSelectedChange(evt) {
            var newTab = evt.target.value;

            _this2.setState({
              hasErrors: false,
              currentTab: newTab
            });
          }
        }, _react.default.createElement(_UITab.default, {
          tabId: 0,
          title: _I18n.default.text((0, _embed.i18nKey)('tabGenearl'))
        }, this.renderErrors(), _react.default.createElement("div", {
          className: "p-x-6"
        }, _react.default.createElement("p", {
          className: "m-bottom-2"
        }, _I18n.default.text((0, _embed.i18nKey)('generalInstructionWithOtherServices'))), _react.default.createElement(_UIFormControl.default, {
          htmlFor: "general_url",
          label: _I18n.default.text((0, _embed.i18nKey)('urlLabel'))
        }, _react.default.createElement(_UITextInput.default, {
          id: "general_url",
          value: url,
          type: "text",
          onChange: function onChange(_ref) {
            var value = _ref.target.value;

            _this2.setState({
              url: value
            });

            _this2.clearEmbed();
          },
          autoFocus: true
        })))), _react.default.createElement(_UITab.default, {
          tabId: 1,
          title: _I18n.default.text((0, _embed.i18nKey)('tabEmbed'))
        }, this.renderErrors(), _react.default.createElement(_UIFormControl.default, {
          htmlFor: "embed_txtarea",
          label: _I18n.default.text((0, _embed.i18nKey)('embedLabel')),
          className: "p-x-6"
        }, _react.default.createElement(_UITextArea.default, {
          autoFocus: true,
          "data-gramm": false,
          defaultValue: embed,
          name: "embed_txtarea",
          onChange: function onChange(_ref2) {
            var value = _ref2.target.value;

            _this2.setState({
              embed: value
            });

            _this2.clearUrl();
          },
          rows: 7,
          value: embed
        }))));
      }

      return _react.default.createElement("div", {
        className: "p-x-10 p-top-8"
      }, _react.default.createElement("p", {
        className: "m-bottom-2"
      }, _I18n.default.text((0, _embed.i18nKey)('generalInstruction'))), this.renderErrors(), _react.default.createElement(_UIFormControl.default, {
        className: "m-bottom-5",
        htmlFor: "general_url",
        label: _I18n.default.text((0, _embed.i18nKey)('urlLabel'))
      }, _react.default.createElement(_UITextInput.default, {
        id: "general_url",
        value: url,
        type: "text",
        onChange: function onChange(_ref3) {
          var value = _ref3.target.value;

          _this2.setState({
            url: value
          });

          _this2.clearEmbed();
        },
        autoFocus: true
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          onClose = _this$props3.onClose,
          className = _this$props3.className,
          onCloseComplete = _this$props3.onCloseComplete;
      return _react.default.createElement(_UIModal.default, {
        width: 550,
        className: className,
        onCloseComplete: onCloseComplete
      }, _react.default.createElement(_UIDialogCloseButton.default, {
        onClick: onClose
      }), _react.default.createElement(_UIDialogHeader.default, null, _react.default.createElement("h4", null, _I18n.default.text((0, _embed.i18nKey)('modalTitle')))), _react.default.createElement(_UIDialogBody.default, {
        className: "p-all-0"
      }, this.renderContent()), _react.default.createElement(_UIDialogFooter.default, null, _react.default.createElement(_UIButton.default, {
        use: "primary",
        onClick: this.submit
      }, _I18n.default.text((0, _embed.i18nKey)('insert'))), _react.default.createElement(_UIButton.default, {
        use: "secondary",
        onClick: onClose
      }, _I18n.default.text((0, _embed.i18nKey)('cancel')))));
    }
  }]);
  return EmbedModal;
}(_react.default.Component);

exports.default = EmbedModal;
EmbedModal.propTypes = {
  url: _react.PropTypes.string,
  embed: _react.PropTypes.string,
  onClose: _react.PropTypes.func.isRequired,
  onSubmit: _react.PropTypes.func.isRequired,
  defaultTab: _react.PropTypes.number,
  enableCodeTab: _react.PropTypes.bool,
  className: _react.PropTypes.string,
  hasNoErrorsUrl: _react.PropTypes.func,
  hasNoErrorsCode: _react.PropTypes.func,
  handleErrorMessage: _react.PropTypes.func,
  onCloseComplete: _react.PropTypes.func
};
EmbedModal.defaultProps = {
  url: '',
  embed: '',
  enableCodeTab: true,
  defaultTab: 0,
  hasNoErrorsUrl: _errorCheck.defaultEmbedUrlErrorCheck,
  hasNoErrorsCode: _errorCheck.defaultEmbedCodeErrorCheck,
  handleErrorMessage: function handleErrorMessage() {
    return (0, _embed.i18nKey)('errorMessage');
  }
};
module.exports = exports.default;